import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MenuQuestionComponent } from '../menu-question/menu-question.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TabularQuestion } from 'src/app/models/TabularQuestion.model';
import { ColumnComponent } from './column/column.component';
import { EStatus } from 'src/app/models/EnumStatus';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { TabularPart } from 'src/app/models/tabularPart.model';
import { TablePartComponent } from './table-part/table-part.component';

@Component({
    selector: 'que-table-question',
    imports: [CommonModule, ColumnComponent, ReactiveFormsModule, TranslateDirective, TranslatePipe, MenuQuestionComponent, TablePartComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: TableQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TableQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './table-question.component.html',
    styleUrls: ['./table-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Output() focusEvent = new EventEmitter<boolean>();

  #builder = inject(FormBuilder);
  questionForm = this.#builder.group({
    id: [-1],
    type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
    title: new FormControl<string>(''),
    text: new FormControl<string>('', [Validators.required]),
    optionsList: new FormControl<OptionsList | null>(null),
    requierd: new FormControl<boolean>(false),
    collectionQuestionId: new FormControl<number | null>(null),
    stepId: [-1],
    columns: this.#builder.array<TabularPart>([]),
    rows: this.#builder.array<TabularPart>([]),
  });

  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      this.registerOnChangeCallback({ ...question });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  // writeValue(obj: String[]): void {
  //   this.optionsValue.patchValue({ op1:obj[0],op2:obj[1] }, { emitEvent: false });
  //   //this.onValidationChangeCallBack();xxx
  // }
  writeValue(obj: Question): void {
    this.questionForm.patchValue({ ...obj }, { emitEvent: false });
    if (obj.columns)
      obj.columns.forEach(tq => this.questionForm.controls.columns.push(new FormControl<TabularPart>(tq)))
    if (obj.rows)
      obj.rows.forEach(tq => this.questionForm.controls.rows.push(new FormControl<TabularPart>(tq)))
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  addColumn() {
    this.questionForm.controls.columns.push(new FormControl<TabularPart>({ order: this.questionForm.controls.columns.length, title: 'עמודה חדשה' }))
  }
  deleteColumn(index: number) {
    this.questionForm.controls.columns.removeAt(index);
  }
  addRow() {
    this.questionForm.controls.rows.push(new FormControl<TabularPart>({ order: this.questionForm.controls.rows.length, title: 'שורה חדשה' }))
  }
  deleteRow(index: number) {
    this.questionForm.controls.rows.removeAt(index);
  }
}

